import { render, staticRenderFns } from "./HmBulletinBoard.vue?vue&type=template&id=560b4697&scoped=true&"
import script from "./HmBulletinBoard.vue?vue&type=script&lang=js&"
export * from "./HmBulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./HmBulletinBoard.vue?vue&type=style&index=0&id=560b4697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b4697",
  null
  
)

component.options.__file = "HmBulletinBoard.vue"
export default component.exports